import { createI18n } from 'vue-i18n'

// 번역 메시지
const messages = {
  ko: {
    common: {
      ok: '확인',
      cancel: '취소',
      save: '저장',
      close: '닫기',
      loading: '로딩 중...'
    },
    form: {
      required: '필수 항목입니다',
      invalid: '올바르지 않은 형식입니다',
      maxLength: '{0}자 이내로 입력해주세요',
      minLength: '{0}자 이상 입력해주세요'
    },
    pages: {
      home: '홈',
      apply: '신청',
      upload: '서류 업로드',
      agreement: '약관 동의',
      verification: '본인 인증',
      complete: '완료'
    }
  }
}

// i18n 인스턴스 생성
export const i18n = createI18n({
  legacy: false, // Composition API 모드
  locale: 'ko',
  fallbackLocale: 'ko',
  messages,
  silentTranslationWarn: true,
  silentFallbackWarn: true
})

export default i18n 